import React, { useEffect, useState } from 'react';
import './index.scss';

import WalletCard from '../../../../../../components/WalletCard/WalletCard';
import HouseMoneyImage from '../../../../../../assets/icons/TargetSavingsAct.svg';
import chevronTable from '../../../../../../assets/icons/chevronTable.svg';
import { useNavigate, useParams } from 'react-router-dom';

import SideSheet from '../../../../../../components/SideSheet/SideSheet';
import HouseMoneySidesheet from '../../Sidesheets/HouseMoney/HouseMoneySidesheet';
import useTargetSavings from '../../../../../../hooks/useTargetSavings';
import TargetSideSheet from '../../../../../../components/NewSideSheet/TargetSideSheet/TargetSideSheet';
import { formatToNaira } from '../../../../../../helpers/utils';
import { formatTargetCreatedDate } from '../../../../../../helpers/utils/targetSavings';
import NoData from '../../../../../../components/NoData/NoData';
import ModalSucess from '../../../../../../components/Modals/ModalSuccess';
import { FormattedAllTarget } from '../../../../../../types';

const index = () => {
  const navigate = useNavigate();
  const [showWalletBalance] = useState(true);
  const [showModalSuccess, setShowModalSuccess] = useState(false);

  const { targetSavingsDetailsQ, pendingTargetSavingsQ, completedTargetSavingsQ, allTargetSavingsQ } =
    useTargetSavings();
  const [showHouseMoneySideSheet, setShowHouseMoneySideSheet] = useState(false);
  const [show, setShow] = useState(false);
  const [activeTab, setActiveTab] = useState('active');
  const walletKey = 'target';

  const params = useParams();
  const id = params.id as string;

  const walletCardsData: any = [
    {
      title: 'Target Balance:',
      balanceKey: targetSavingsDetailsQ?.walletBalance ?? 0,
      cardId: 'hm-card',
      image: HouseMoneyImage,
      isActive: true,
      isOpenSideSheet: true,
      // cardClick: () => setShowHouseMoneySideSheet(Object.keys(houseMoneyDetails).length ? true : false),
    },
  ];

  const [searchQuery, setSearchQuery] = useState('');

  // The wallet tab only previews 5 rows; searching hands off to the paginated view-all page.
  const goToViewAll = (query = '') => {
    const q = query.trim();
    navigate(`/view-all-targets/${id}/${activeTab}${q ? `?q=${encodeURIComponent(q)}` : ''}`);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    goToViewAll(searchQuery);
  };

  const showViewAll = () => {
    if (activeTab === 'active') {
      return pendingTargetSavingsQ?.list.length > 0;
    }

    if (activeTab === 'completed') {
      return completedTargetSavingsQ?.list.length > 0;
    }

    if (activeTab === 'all') {
      return allTargetSavingsQ?.list?.length > 0;
    }
  };

  const getActiveTabLabel = () => {
    if (activeTab === 'active') return 'Active Targets';
    if (activeTab === 'completed') return 'Completed Targets';
    return 'All Targets';
  };

  useEffect(() => {
    // add tab to url

    navigate('?wallet=target&status=' + activeTab, { replace: true });
  }, [activeTab]);

  return (
    <>
      <div className="wallet-targets-page">
        <div className="cards-container flex--2">
          {walletCardsData.map((item: any, i: any) => (
            <WalletCard
              key={i}
              {...item}
              showBalance={showWalletBalance}
              balance={item.balanceKey}
              walletKey={walletKey}
            />
          ))}
        </div>
        <div className="wallets-details">
          <div className="tab-switch flex--2">
            <p className={`pointer tab ${activeTab === 'active' && 'active'}`} onClick={() => setActiveTab('active')}>
              Active Targets
            </p>
            <p
              className={`pointer tab ${activeTab === 'completed' && 'active'}`}
              onClick={() => setActiveTab('completed')}
            >
              Completed Targets
            </p>
            <p className={`pointer tab ${activeTab === 'all' && 'active'}`} onClick={() => setActiveTab('all')}>
              All Targets
            </p>
          </div>
          <div className="customers-filter">
            <div className="input-field">
              <form action="" onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="Search targets by title"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  aria-label="Search targets by title"
                />
              </form>
            </div>
            <div className="query-filter" onClick={() => goToViewAll(searchQuery)}>
              <div>
                <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                    stroke="#1E293B"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                  />
                </svg>
              </div>
              <div>Search</div>
            </div>
            <div className="query-filter" onClick={() => setSearchQuery('')}>
              <div></div>
              <div>Reset</div>
            </div>
          </div>
        </div>

        {showViewAll() && (
          <div className="flex--3">
            <p className="active-text"> {getActiveTabLabel()}</p>
            <p className="view-all-g pointer" onClick={() => goToViewAll()}>
              View all
            </p>
          </div>
        )}

        <div className="table-target flex--4">
          {activeTab === 'active' && (
            <>
              {pendingTargetSavingsQ?.list.length ? (
                pendingTargetSavingsQ?.list?.slice(0, 5).map((item: any, key: any) => (
                  <div
                    className="row-t pointer flex--2"
                    key={key}
                    onClick={() => {
                      navigate(`/view-target/${id}/${item.targetId}`);
                    }}
                  >
                    <div className="img-cont">
                      <img src={item.image} alt="" />
                    </div>

                    <div className="sect-1 flex--4">
                      <h3>{item.title}</h3>
                      <small>ID: {item.targetId}</small>
                      <small>{formatToNaira(item?.keyPoints[2]?.value ?? 0)} Daily</small>
                    </div>

                    <div className="sect-1 end flex--4">
                      <h3>{item?.keyPoints[1]?.value}</h3>
                    </div>
                    <img className="chevron-table" src={chevronTable} />
                  </div>
                ))
              ) : (
                <NoData message={'No Active Targets at the moment.'} />
              )}
            </>
          )}

          {activeTab === 'completed' && (
            <>
              {completedTargetSavingsQ?.list.length ? (
                completedTargetSavingsQ?.list?.slice(0, 5).map((item: any, key: any) => (
                  <div
                    className="row-t pointer flex--1"
                    key={key}
                    onClick={() => {
                      navigate(`/view-target/${id}/${item.targetId}`);
                    }}
                  >
                    <div className="img-cont">
                      <img src={item.image} alt="" />
                    </div>

                    <div className="sect-1 flex--4">
                      <h3>{item.title}</h3>
                      <small>ID: {item.targetId}</small>
                      <small>N1,000 daily</small>
                    </div>

                    <div className="sect-1 end flex--4">
                      <h3>{item?.keyPoints[1]?.value}</h3>
                      <small>Ends: February 24. 2025</small>
                    </div>
                    <img className="chevron-table" src={chevronTable} />
                  </div>
                ))
              ) : (
                <NoData message={'No Completed Target at the moment.'} />
              )}
            </>
          )}

          {activeTab === 'all' && (
            <>
              {allTargetSavingsQ?.list?.length ? (
                allTargetSavingsQ.list.slice(0, 5).map((item: FormattedAllTarget, key: number) => (
                  <div
                    className="row-t pointer flex--1"
                    key={key}
                    onClick={() => {
                      navigate(`/view-target/${id}/${item.targetId}`);
                    }}
                  >
                    <div className="img-cont">
                      <img src={HouseMoneyImage} alt="" />
                    </div>

                    <div className="sect-1 flex--4">
                      <h3>{item.title}</h3>
                      <small>ID: {item.targetId}</small>
                    </div>

                    <div className="sect-1 end flex--4">
                      <small>Created: {formatTargetCreatedDate(item.createdAt)}</small>
                    </div>
                    <img className="chevron-table" src={chevronTable} />
                  </div>
                ))
              ) : (
                <NoData message={'No targets at the moment.'} />
              )}
            </>
          )}
        </div>
      </div>

      {showHouseMoneySideSheet && (
        <SideSheet active={showHouseMoneySideSheet} onClose={() => setShowHouseMoneySideSheet(false)} hideCloseButton>
          <HouseMoneySidesheet userId={id} onClose={() => setShowHouseMoneySideSheet(false)}></HouseMoneySidesheet>
        </SideSheet>
      )}

      <TargetSideSheet
        show={show}
        id={''}
        data={{}}
        onClose={() => {
          setShow(false);
        }}
      />
      <ModalSucess modalIsOpen={showModalSuccess} setIsOpen={setShowModalSuccess} />
    </>
  );
};

export default index;
